/**
 * ⚠️ TEXTO PROVISIONAL — PENDIENTE DE CONTENIDO REAL DEL CLIENTE.
 *
 * Todo el copy del sitio vive aquí para que reemplazarlo sea cambiar un solo
 * archivo, sin tocar componentes. Nada de esto está verificado con el cliente:
 * son textos de trabajo, plausibles pero inventados, para poder maquetar.
 *
 * NO contiene testimonios: el cliente no ha confirmado si tiene reseñas
 * reales y no se inventan.
 */

export const marca = {
  // 'Leopard Cats' con espacio: pegado ('Leopardscats') se lee ambiguo como
  // "leopard scats" en inglés. El espacio no toca el dominio, que sigue
  // siendo leopardscats.com (ya registrado y conectado).
  //
  // PENDIENTE del cliente: en las cotizaciones/documentos de Vitrina Dev el
  // nombre comercial usado es "Bengal Leopard Cats" (sin tilde, en inglés);
  // este sitio usa "Bengalí Leopard Cats" (con tilde). Es una inconsistencia
  // de marca — hay que definir cuál es el nombre oficial antes del logo
  // definitivo.
  nombre: 'Bengalí Leopard Cats',
  // PENDIENTE: eslogan real.
  eslogan: 'El cuidado que una raza excepcional merece',
}

// Rutas absolutas (no "#seccion" a secas): así funcionan igual desde la
// portada que desde la ficha de un gatico, vía el componente Enlace.
export const navegacion = [
  { href: '/#catalogo', etiqueta: 'Disponibles' },
  { href: '/#marca', etiqueta: 'El criadero' },
  { href: '/quienes-somos', etiqueta: 'Quiénes somos' },
  { href: '/educacion', etiqueta: 'Educación' },
  { href: '/#cuidados', etiqueta: 'Cuidados' },
  { href: '/#envios', etiqueta: 'Entrega' },
  { href: '/preguntas-frecuentes', etiqueta: 'Preguntas' },
  { href: '/#contacto', etiqueta: 'Contacto' },
]

export const sobreLaMarca = {
  titulo: 'Criadero especializado en razas exóticas',
  parrafos: [
    'Nuestra historia empezó conviviendo día a día con el gato Bengalí. Entendimos rápido que no es un gato común: su energía, su inteligencia y sus rosetas únicas requieren una crianza experta. Nos dedicamos exclusivamente a preservar la belleza salvaje y el carácter dócil de la raza, priorizando la salud genética y el bienestar en cada camada.',
    'Por eso trabajamos con pocas camadas a la vez. Cada cachorro se entrega desparasitado, con su esquema de vacunación al día y después de haber sido evaluado por nuestro veterinario. Si algo no cumple ese estándar, no sale del criadero.',
  ],
  pilares: [
    {
      titulo: 'Genética cuidada',
      texto: 'Líneas de sangre documentadas y cruces planeados, no camadas al azar.',
    },
    {
      titulo: 'Asesoría directa',
      texto: 'Atención por WhatsApp con quien conoce la raza, no con un formulario automático.',
    },
    {
      titulo: 'Acompañamiento',
      texto: 'Resolvemos dudas de adaptación y cuidado después de la entrega, no solo antes.',
    },
  ],
}

/**
 * Página /quienes-somos — a diferencia del resto del copy de este archivo,
 * esto NO es texto provisional: viene directo del documento de planeación
 * estratégica que entregó el cliente (misión, visión, valores corporativos y
 * objetivos ya redactados y aprobados por él), no de un borrador inventado
 * para maquetar. Se transcribe casi literal, solo puliendo el nombre de
 * marca a la forma que usa el resto del sitio ("Bengalí Leopard Cats").
 *
 * El eslogan es el que el propio documento identifica como el elegido para
 * la imagen del criadero profesional, de entre varias opciones propuestas.
 */
export const quienesSomos = {
  eslogan: 'Belleza salvaje, crianza responsable.',
  mision: {
    titulo: 'Misión',
    parrafos: [
      'En Bengalí Leopard Cats nos dedicamos a la crianza selectiva, responsable y ética de gatos bengalíes, promoviendo el mejoramiento genético de la raza mediante programas de reproducción cuidadosamente planificados, enfocados en la salud, el temperamento, la belleza y la preservación de sus características distintivas.',
      'Nuestro compromiso es garantizar el máximo bienestar de cada ejemplar desde su nacimiento, brindándole un entorno seguro, enriquecido y supervisado profesionalmente. Trabajamos para entregar a nuestros clientes compañeros sanos, socializados y de excelente calidad genética, acompañándolos con asesoría y apoyo permanente para fomentar una tenencia responsable y una experiencia de satisfacción integral.',
    ],
  },
  vision: {
    titulo: 'Visión',
    parrafos: [
      'Ser reconocidos a nivel nacional e internacional como un criadero de referencia en la crianza responsable de gatos bengalíes, destacándonos por la excelencia genética de nuestras líneas, nuestros altos estándares de bienestar animal y la confianza depositada por nuestros clientes.',
      'Aspiramos a contribuir al desarrollo y fortalecimiento de la raza mediante la implementación de programas de selección genética basados en criterios de salud, funcionalidad y calidad, consolidando una comunidad de propietarios comprometidos con el cuidado responsable y el amor por los gatos bengalíes.',
    ],
  },
  valores: [
    {
      titulo: 'Bienestar animal',
      texto: 'La salud física y emocional de nuestros gatos es el eje fundamental de todas nuestras decisiones.',
    },
    {
      titulo: 'Responsabilidad',
      texto: 'Actuamos con ética y transparencia en cada proceso de reproducción, selección y entrega de nuestros ejemplares.',
    },
    {
      titulo: 'Excelencia genética',
      texto: 'Trabajamos continuamente en el mejoramiento de nuestras líneas reproductivas mediante una selección rigurosa basada en criterios sanitarios, morfológicos y comportamentales.',
    },
    {
      titulo: 'Calidad',
      texto: 'Mantenemos altos estándares de manejo, nutrición, medicina preventiva y socialización para garantizar ejemplares sobresalientes.',
    },
    {
      titulo: 'Compromiso con el cliente',
      texto: 'Construimos relaciones de confianza brindando información, acompañamiento y asesoría antes, durante y después de la entrega de cada gato.',
    },
    {
      titulo: 'Educación y tenencia responsable',
      texto: 'Promovemos prácticas de cuidado responsable y fomentamos el conocimiento sobre las necesidades y características de la raza bengalí.',
    },
  ],
  objetivoGeneral:
    'Desarrollar un programa de crianza selectiva de gatos bengalíes orientado al mejoramiento genético, la preservación de la salud y el bienestar animal, ofreciendo ejemplares de alta calidad que satisfagan las expectativas de familias, aficionados y criadores responsables.',
  objetivosEspecificos: [
    'Implementar programas de selección genética que reduzcan la incidencia de enfermedades hereditarias y fortalezcan las características deseables de la raza.',
    'Garantizar condiciones óptimas de bienestar, nutrición, manejo sanitario y enriquecimiento ambiental para todos los ejemplares del criadero.',
    'Mantener registros genealógicos, reproductivos y sanitarios detallados que permitan una gestión técnica y responsable del programa de cría.',
    'Entregar gatitos socializados, sanos y adecuadamente preparados para su integración en nuevos hogares.',
    'Brindar acompañamiento y asesoría permanente a los propietarios para promover una tenencia responsable.',
    'Posicionar a Bengalí Leopard Cats como una marca reconocida por la calidad genética, la ética de crianza y la excelencia en el servicio al cliente.',
  ],
  // Diferenciador que propone el propio documento estratégico frente a otros
  // criaderos: la mayoría comunica solo el patrón del manto.
  diferenciador:
    'Un criadero dirigido por un médico veterinario, donde cada decisión reproductiva se basa en salud, genética y bienestar — no solo en el patrón del manto.',
}

export const cuidados = {
  titulo: 'Cuidados esenciales del gato Bengalí',
  entradilla:
    'Tres aspectos clave donde el Bengalí se aparta del cuidado felino convencional. Es fundamental conocerlos antes de integrar un cachorro a tu hogar.',
  articulos: [
    {
      titulo: 'Nutrición de alta demanda proteica',
      texto: 'Su metabolismo activo y masa muscular requieren un concentrado de alto valor nutricional y calidad premium, con proteína animal identificada como primer ingrediente y libre de rellenos genéricos, para mantener su vitalidad y la calidad de su manto.',
    },
    {
      titulo: 'Mantenimiento del manto con Glitter',
      texto: 'Aunque su pelo es corto y de bajo mantenimiento, la salud de sus rosetas y su brillo caracteístico (glitter) dependen de un aporte óptimo de ácidos grasos Omega-3 y Omega-6 en su alimentación diaria.',
    },
    {
      titulo: 'Enriquecimiento ambiental y altura',
      texto: 'Posee un instinto cazador y una gran inteligencia. Requiere rascadores altos, espacios verticales y juguetes interactivos; sin el estímulo adecuado, buscará canalizar su energía en muebles o cortinas.',
    },
  ],
}

export const envios = {
  titulo: 'Entrega y garantía de salud',
  puntos: [
    {
      titulo: 'Cobertura de entrega',
      texto: 'Entrega presencial en Rionegro, Llanogrande y Medellín. Para el resto de Colombia coordinamos transporte de mascotas; los envíos internacionales se gestionan mediante contratación especializada y quedan sujetos a las regulaciones del país de destino.',
    },
    {
      titulo: 'Documentos y trazabilidad',
      texto: 'Cada cachorro sale con carné de vacunación y desparasitación al día, certificado de salud firmado por veterinario, microchip de identificación y registro oficial TICA.',
    },
    {
      titulo: 'Garantía y acompañamiento',
      // PENDIENTE: plazo y condiciones exactas de la garantía (detalle en
      // entregaGarantia). El acompañamiento de 2 meses sí es un dato
      // confirmado por el cliente, no un placeholder.
      texto: 'Garantía de salud por escrito, más 2 meses de asesoría directa y personalizada con el médico veterinario del criadero después de la entrega.',
    },
  ],
  // Enlaza a la política completa (/entrega-y-garantia): estos tres puntos
  // son el resumen para la portada, no la política entera.
  enlaceCompleto: { href: '/entrega-y-garantia', etiqueta: 'Ver la política completa' },
  // CTA directo a WhatsApp Business para dudas puntuales de envío/cobertura,
  // sin tener que primero elegir un gatico del catálogo (a diferencia del
  // botón "Preguntar por WhatsApp" de cada ficha, este mensaje no depende de
  // ningún producto — se arma en el cliente, no en la Cloud Function).
  whatsappCta: {
    etiqueta: 'Consultar envíos por WhatsApp',
    mensaje:
      'Hola, quiero consultar sobre la entrega o el envío de un gatico: zona de cobertura, tiempos y costos.',
  },
}

/**
 * Política de entrega y garantía de salud — borrador de trabajo, igual que
 * el resto del copy del sitio. Los plazos y porcentajes concretos (72 horas,
 * 30 días, quién paga el transporte) son valores por defecto razonables para
 * la industria, PENDIENTES de que el cliente los confirme o ajuste antes de
 * producción — no son términos ya pactados con nadie.
 *
 * Los términos que de verdad rigen cada venta quedan en el contrato de
 * compraventa que se firma en el momento de la entrega: esta página es un
 * resumen público, no el contrato.
 */
export const entregaGarantia = {
  titulo: 'Política de entrega y garantía de salud',
  actualizado: '27 de agosto de 2026',
  // Opcional (ver DocumentoLegal.jsx): CTA de cierre hacia WhatsApp Business
  // para gestionar envíos o resolver dudas puntuales de cobertura. Privacidad
  // usa el mismo componente sin este campo y simplemente no lo muestra.
  ctaWhatsapp: {
    etiqueta: 'Consultar o gestionar envíos por WhatsApp',
    mensaje:
      'Hola, quiero consultar sobre la entrega o el envío de un gatico: zona de cobertura, tiempos y costos.',
  },
  secciones: [
    {
      titulo: 'Alcance',
      parrafos: [
        'Esta política aplica a todos los cachorros Bengalí, Sphynx y Savannah que salen del criadero. Los términos exactos de cada venta —incluida la garantía— quedan por escrito en el contrato de compraventa que firmas al momento de la entrega; esta página es un resumen para que sepas qué esperar antes de escribirnos.',
      ],
    },
    {
      titulo: 'Cobertura nacional',
      parrafos: [
        'Preferimos la entrega presencial en Rionegro, Llanogrande y Medellín: así conoces al cachorro, resolvemos dudas en el momento y evitamos el estrés de un viaje innecesario.',
        'Para el resto de Colombia coordinamos el envío a través de un transportador de mascotas certificado. El costo del transporte corre por cuenta del comprador y se cotiza aparte según destino.',
        'En ningún caso el cachorro viaja antes de cumplir la edad mínima que indica el veterinario (típicamente 12 semanas, tras el primer refuerzo de vacunas): es una condición de salud, no una preferencia logística, y no negociamos sobre esto.',
      ],
    },
    {
      titulo: 'Cobertura internacional',
      parrafos: [
        'Los envíos internacionales se gestionan mediante contratación especializada (agencia de transporte de mascotas con experiencia en trámites de exportación) y quedan sujetos a las regulaciones sanitarias y de importación del país de destino, que varían de un caso a otro.',
        'Si te interesa un envío internacional, escríbenos por WhatsApp con el país de destino antes de reservar: confirmamos contigo la viabilidad, los tiempos y el costo estimado del trámite antes de avanzar.',
      ],
    },
    {
      titulo: 'Qué recibes el día de la entrega',
      parrafos: [
        'Carné de vacunación y desparasitación al día, certificado de salud firmado por veterinario emitido pocos días antes de la entrega, microchip de identificación ya implantado, y registro oficial TICA. Si el cachorro tiene registro de pedigree adicional, el certificado se tramita y se entrega en un lapso de 3 a 6 meses después de la entrega.',
      ],
    },
    {
      titulo: 'Revisión veterinaria inicial',
      parrafos: [
        'Debes llevar al cachorro a un veterinario de tu confianza dentro de las 72 horas siguientes a la entrega, por tu cuenta. Es la mejor manera de detectar cualquier condición a tiempo y es requisito para poder hacer válida la garantía de salud.',
      ],
    },
    {
      titulo: 'Garantía de salud',
      parrafos: [
        'Si dentro de los 30 días siguientes a la entrega un veterinario diagnostica por escrito una condición congénita o hereditaria grave —no causada por el manejo posterior a la entrega—, la resolvemos reemplazando el cachorro por otro de valor equivalente en la siguiente camada disponible, o según lo que hayamos acordado por escrito en el contrato.',
        'La garantía no cubre: enfermedades o lesiones ocurridas después de la entrega por accidentes, mal manejo, no completar el esquema de vacunación en las fechas indicadas, o exposición a otros animales sin vacunar. Tampoco cubre condiciones que ya constaban en el certificado veterinario de salud entregado el día de la venta.',
      ],
    },
    {
      titulo: 'Asesoría veterinaria post-entrega',
      parrafos: [
        'Además de la garantía de salud, todo cachorro incluye 2 meses de asesoría directa y personalizada con el médico veterinario del criadero: dudas sobre alimentación, comportamiento, esquema de vacunación o cualquier señal que te preocupe puedes consultarlas directamente, sin costo adicional, dentro de ese plazo.',
        'Esta asesoría es un acompañamiento, no un reemplazo de las consultas veterinarias presenciales que ya son tu responsabilidad (ver "Revisión veterinaria inicial" arriba): la usamos para orientarte, no para diagnosticar a distancia.',
      ],
    },
    {
      titulo: 'Cómo reclamar la garantía',
      parrafos: [
        'Escríbenos por WhatsApp con el diagnóstico veterinario por escrito apenas lo tengas, dentro del plazo de garantía. Respondemos para acordar los siguientes pasos; no hace falta ningún trámite adicional de tu parte.',
      ],
    },
    {
      titulo: 'Qué no es esta garantía',
      parrafos: [
        'Un cachorro no es un producto que se devuelve por cambio de opinión: la garantía cubre condiciones de salud, no arrepentimiento de la compra. Si por una razón mayor de verdad no puedes continuar con el cuidado del gatico, cuéntanos: te ayudamos a encontrarle un hogar responsable antes que a cualquier otra alternativa.',
      ],
    },
  ],
}

/**
 * FAQ pública en /preguntas-frecuentes — nace de comparar nuestro contenido
 * de /educacion contra la página de FAQ de un competidor (Dinastía Bengalí):
 * ellos resuelven bien lo transaccional (precio, cómo comprar, reserva,
 * envío) y hoy nosotros no respondemos nada de eso fuera de la conversación
 * de WhatsApp. Esta lista cierra esa brecha con la realidad actual del
 * sitio —sin carrito ni pago en línea, sin inventar precios ni política de
 * depósito— y cierra con un gancho hacia el contenido de confianza
 * (pruebas genéticas, pedigree, criterio de criadero ético) que si tenemos
 * y el competidor no publica.
 *
 * `enlace` es opcional (ver FaqAcordeon.jsx): cuando está presente, la
 * respuesta cierra con un link real a la página completa correspondiente.
 */
export const preguntasFrecuentes = [
  {
    pregunta: '¿Quiénes somos?',
    respuesta:
      'Un criadero especializado exclusivamente en razas exóticas (Bengalí, Sphynx y Savannah), enfocado en genética cuidada, salud certificada y acompañamiento después de la entrega — no en volumen de camadas.',
  },
  {
    pregunta: '¿Cómo funciona el proceso de compra?',
    respuesta:
      'Eliges el gatico que te interesa en el catálogo y preguntas por él con el botón "Preguntar por WhatsApp" de su ficha. A partir de ahí, la forma de pago, la reserva y la entrega se coordinan directamente en esa conversación: hoy el sitio no tiene carrito ni pago en línea.',
  },
  {
    pregunta: '¿Cómo es la entrega?',
    respuesta:
      'Preferimos la entrega en persona en la ciudad del criadero; si estás en otra ciudad, se coordina con un transportador de mascotas certificado. El cachorro nunca viaja antes de la edad mínima que indica el veterinario.',
    enlace: { href: '/entrega-y-garantia', etiqueta: 'Ver la política completa de entrega y garantía' },
  },
  {
    pregunta: '¿Qué garantía tiene?',
    respuesta:
      'Cubre condiciones congénitas o hereditarias graves que un veterinario diagnostique por escrito dentro del plazo de garantía, siempre que hagas la revisión veterinaria inicial a tiempo. Las exclusiones y el detalle completo están en la política.',
    enlace: { href: '/entrega-y-garantia', etiqueta: 'Ver la política completa de entrega y garantía' },
  },
  {
    pregunta: '¿Cuánto cuesta un gatico?',
    // PENDIENTE: el cliente puede querer publicar un rango de precio general
    // (ver comparativa con Dinastía Bengalí) — no se asume sin confirmar.
    respuesta:
      'El precio varía según la raza, la generación y las características de cada ejemplar, así que no publicamos una tarifa única: lo ves directamente en la ficha de cada gatico disponible en el catálogo.',
    enlace: { href: '/#catalogo', etiqueta: 'Ver el catálogo' },
  },
  {
    pregunta: '¿Por qué hay gaticos esterilizados y otros no?',
    respuesta:
      'Todo gatico se entrega esterilizado por defecto, listo para ser mascota — es la modalidad pensada para compañía. En los ejemplares donde el cliente solicita ofrece la alternativa, también se puede entregar enteros, con fines de cría o exposición: ahí el precio sube (hasta un 50% sobre el valor base, según el ejemplar), porque no es lo mismo vender un gatico para acompañar a una familia que uno con potencial reproductivo o de exhibición, con todo lo que eso implica en manejo, líneas genéticas y responsabilidad para quien lo recibe. Cuando un gatico ofrece ambas modalidades, ves los dos precios en su ficha.',
  },
  {
    pregunta: '¿Necesito pagar un depósito para reservar?',
    // PENDIENTE: definir con el cliente si se formaliza una política de
    // depósito/reserva (ver comparativa con Dinastía Bengalí).
    respuesta:
      'Hoy no tenemos un sistema de depósito o reserva en línea. La disponibilidad de cada gatico se confirma directamente por WhatsApp en el momento en que preguntas por él.',
  },
  {
    pregunta: '¿Cómo sé que es un criadero serio?',
    respuesta:
      'No te pedimos que nos creas por afirmarlo: te contamos qué debería mostrarte cualquier criadero serio antes de que reserves —pruebas genéticas, seguimiento cardiológico, acceso a ver a la madre— para que puedas verificarlo tú mismo.',
    enlace: {
      href: '/educacion/guia-comprador-responsable/criadero-etico',
      etiqueta: 'Ver los criterios de un criadero ético',
    },
  },
]

export const contacto = {
  titulo: 'Hablemos',
  entradilla:
    'Cuéntanos qué raza te interesa y qué buscas en tu próximo gatico. Respondemos por el mismo medio por el que escribas.',
}

/**
 * PENDIENTE: enlaces reales de redes sociales y ubicación, si aplica. El
 * componente (RedesSociales.jsx) y sus íconos (Instagram, Facebook, TikTok)
 * ya están listos; solo falta llenar este array cuando existan las cuentas
 * reales del criadero. No se inventan perfiles ni se publican enlaces
 * falsos mientras tanto.
 *
 * Forma esperada de cada entrada:
 *   { id: 'instagram' | 'facebook' | 'tiktok', nombre: string, url: string }
 *
 * `id` selecciona el ícono en RedesSociales.jsx; una red sin ícono propio
 * cae de vuelta a mostrar `nombre` en texto. Ejemplo (no usar, ilustrativo):
 *   { id: 'instagram', nombre: 'Instagram', url: 'https://instagram.com/...' }
 *
 * PENDIENTE: Facebook y TikTok — el cliente aún no confirma esos perfiles.
 * Agregar aquí en cuanto los tengamos, con el mismo formato que Instagram.
 */
export const redes = [
  { id: 'instagram', nombre: 'Instagram', url: 'https://www.instagram.com/bengalileopardcats' },
]

/**
 * Aviso de privacidad — robustecido contra los requisitos de la Ley 1581 de
 * 2012 y el Decreto 1377 de 2013 (habeas data, Colombia): identificación
 * completa del responsable, los 8 derechos del artículo 8, plazos legales de
 * respuesta, transferencia internacional (Firebase/Google Cloud) y
 * conservación de datos, que la versión anterior no cubría.
 *
 * Esto es una revisión de contenido para que el aviso sea más completo
 * frente a la ley citada, NO una revisión legal certificada: sigue siendo un
 * borrador de trabajo y no reemplaza el concepto de un abogado antes de
 * producción. Faltan, además, datos reales del responsable (NIT, dirección
 * física, correo de contacto) que hoy no existen y hay que completar cuando
 * el cliente los tenga — mientras tanto el único canal de contacto real es
 * WhatsApp.
 */
export const privacidad = {
  titulo: 'Aviso de privacidad',
  actualizado: '30 de julio de 2026',
  notaBorrador:
    'Este aviso está en revisión: falta el visto bueno de un abogado y datos del responsable (NIT, dirección física) que todavía no existen. No lo tomes como asesoría legal definitiva.',
  secciones: [
    {
      titulo: 'Responsable del tratamiento',
      parrafos: [
        // PENDIENTE: razón social/NIT y dirección física reales del negocio.
        // Sin esos datos, el aviso solo puede identificar el nombre de marca.
        `${'Bengalí Leopard Cats'} es responsable del tratamiento de los datos personales que se describen en este aviso. Por ahora el único canal de contacto disponible para ejercer tus derechos es WhatsApp o el formulario de contacto del sitio; un correo electrónico y una dirección física se agregarán aquí cuando el negocio los tenga formalizados.`,
      ],
    },
    {
      titulo: 'Qué datos recogemos',
      parrafos: [
        'Si inicias sesión con Google: tu nombre, correo y foto de perfil, tal como los provee tu cuenta de Google.',
        'Si usas el sitio con sesión iniciada: los gaticos que marques como favoritos, las reseñas que escribas y un registro de los gaticos que hayas consultado por WhatsApp (no confirma que la venta se haya concretado).',
        'Si escribes por el formulario de contacto: el nombre, correo y mensaje que ingreses ahí.',
        'Si preguntas por un gatico por WhatsApp: su nombre y precio viajan en el mensaje prellenado; la conversación que sigue ocurre dentro de WhatsApp, fuera de este sitio y de este aviso.',
      ],
    },
    {
      titulo: 'Para qué los usamos',
      parrafos: [
        'Para identificar quién escribe cada reseña, mostrarte tus favoritos y tu historial en "Mi perfil", responder tus mensajes de contacto y gestionar consultas por WhatsApp. No usamos tus datos para nada distinto a esto, y en particular no los usamos para armar perfiles publicitarios ni para venderlos.',
      ],
    },
    {
      titulo: 'Dónde se almacenan y transferencia internacional',
      parrafos: [
        'En Firebase (infraestructura de Google Cloud): Firestore para los datos y Firebase Authentication para la sesión. El acceso está restringido por reglas de seguridad: cada persona solo puede leer sus propios favoritos, reseñas y pedidos.',
        'Google actúa aquí como Encargado del Tratamiento, no como Responsable: procesa los datos siguiendo nuestras instrucciones, no las suyas propias. Sus servidores pueden estar ubicados fuera de Colombia; Google aplica cláusulas contractuales y medidas de seguridad estándar de la industria para esa transferencia internacional, exigidas por su propio marco de cumplimiento.',
      ],
    },
    {
      titulo: 'Con quién los compartimos',
      parrafos: [
        'No vendemos ni cedemos tus datos a terceros con fines comerciales. Las reseñas aprobadas se muestran públicamente con el nombre asociado a tu cuenta de Google. Fuera de Google/Firebase (como Encargado del Tratamiento, según el punto anterior), no compartimos tus datos con nadie más.',
      ],
    },
    {
      titulo: 'Cuánto tiempo conservamos tus datos',
      parrafos: [
        'Mientras exista la finalidad que los justifica: tus favoritos y reseñas, mientras mantengas tu cuenta activa; los mensajes de contacto, el tiempo necesario para atenderlos. Puedes pedir la eliminación de tus datos en cualquier momento, según se explica abajo.',
      ],
    },
    {
      titulo: 'Tus derechos',
      parrafos: [
        'Como titular de tus datos, en cualquier momento tienes derecho a: conocerlos, actualizarlos y rectificarlos cuando sean parciales, inexactos o desactualizados; solicitar prueba de la autorización que nos diste; ser informado sobre el uso que les hemos dado; presentar quejas ante la Superintendencia de Industria y Comercio (SIC) por infracciones a la ley; revocar la autorización y/o solicitar la supresión del dato cuando no se respeten los principios y deberes legales; y acceder de forma gratuita a tus datos personales que hayan sido objeto de tratamiento.',
        'Escríbenos por WhatsApp o por el formulario de contacto para ejercer cualquiera de estos derechos. Respondemos las consultas dentro de los 10 días hábiles siguientes (prorrogable 5 días hábiles más si te avisamos antes de que venza el plazo) y los reclamos dentro de los 15 días hábiles siguientes, como lo exige la ley.',
      ],
    },
  ],
}
